var _path, _rect, _rect2, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTextColor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Text_Color_Icon",
    "data-name": "Text Color Icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.739,
    height: 16,
    viewBox: "0 0 11.739 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1300",
    "data-name": "Path 1300",
    d: "M5.778,2.627,7.39,6.8H4.2ZM4.556,0,0,11.257H2.506L3.471,8.7H8.148l1.022,2.557h2.569L7.055,0Z",
    fill: "#2a2a2a"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5093",
    "data-name": "Rectangle 5093",
    width: 3.556,
    height: 3.556,
    transform: "translate(0 12.444)",
    fill: "#45a735"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5094",
    "data-name": "Rectangle 5094",
    width: 3.556,
    height: 3.556,
    transform: "translate(4.092 12.444)",
    fill: "#0063b0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5095",
    "data-name": "Rectangle 5095",
    width: 3.556,
    height: 3.556,
    transform: "translate(8.182 12.444)",
    fill: "#cc004a"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextColor);
export default __webpack_public_path__ + "static/media/textColor.3e2b71c3544cfca99cd765004f71af80.svg";
export { ForwardRef as ReactComponent };